import { showFsImage } from '../js/fs-img';
import { all } from './util';

(() => {
    let canShowFullscreen = true;
    let imageDescriptionTimeout = 0;

    // gets all image elements inside a container
    const getImageElements = (container: Element) => {
        console.log(all('img', container));
        return all<HTMLImageElement>('img', container);
    }

    // take the last one and place it on the left
    const moveRight = (container: Element) => {
        const images = getImageElements(container);
        const parent = images[images.length - 1].parentElement;
        if (parent) {
            parent.insertBefore(images[images.length - 1], images[0]);
        }
    }

    // take the first one and place it on the right
    const moveLeft = (container: Element) => {
        const images = getImageElements(container);
        const parent = images[0].parentElement;
        if (parent) {
            parent.insertBefore(images[0], images[images.length - 1].nextSibling);
        }
    }

    // add 'fullscreen image' display on click
    const initPhotoboxImages = (container: Element) => {
        getImageElements(container).forEach(i => i.addEventListener('click', e => {
            if (e instanceof HTMLImageElement) {
                showFsImage(e);
            }
        }))
    }

    // init left/right arrows
    const initPhotoboxArrows = (container: Element) => {
        all('.left').forEach(l => {
            l.addEventListener('click', () => {
                clearTimeout(imageDescriptionTimeout);
                tempDisableFsImage();
                moveLeft(container);
                printImageDescription(container);
            });
        });
        all('.right').forEach(r => {
            r.addEventListener('click', () => {
                clearTimeout(imageDescriptionTimeout);
                tempDisableFsImage();
                moveRight(container);
                printImageDescription(container);
            });
        });
    }

    const getImageDescription = (container: Element) => {
        const images = getImageElements(container);
        if (images.length >= 2) {
            const activeImage = images[1];
            return activeImage.getAttribute('alt');
        }
        return '';
    }

    const printImageDescription = (container: Element) => {
        const description = getImageDescription(container) || '';
        const descriptionBox = container.nextElementSibling?.lastElementChild;

        if (descriptionBox) {
            recPrintDescription(descriptionBox, 0, description);
        }
    }

    const recPrintDescription = (descriptionBox: Element, index: number, description: string) => {
        if (description.length + 1 === index) {
            return;
        } else if (descriptionBox instanceof HTMLElement) {
            const characterToPrint = description.charAt(index - 1);
            const characterToPrintIsSpace = characterToPrint === ' ';

            if (characterToPrintIsSpace) {
                descriptionBox.innerText = description.substring(0, index + 1);
                imageDescriptionTimeout = window.setTimeout(() => recPrintDescription(descriptionBox, index + 2, description), 30)
            } else {
                descriptionBox.innerText = description.substring(0, index);
                imageDescriptionTimeout = window.setTimeout(() => recPrintDescription(descriptionBox, index + 1, description), 30);
            }
        }
    }

    // disables triggering of 'fullscreen image' while the image is moving
    const tempDisableFsImage = () => {
        canShowFullscreen = false;
        window.setTimeout(() => {
            canShowFullscreen = false;
        }, 600);
    }

    // initializes all photoboxes on the page
    all('.photobox').forEach(p => {
        initPhotoboxArrows(p);
        initPhotoboxImages(p);
    });
})()